
import { IGetComponentInfoWithStatusParameters } from "./IGetComponentInfoWithStatusParameters";


export class GetComponentInfoWithStatusParameters implements IGetComponentInfoWithStatusParameters
{
    componentId: string = "";
    date: Date = new Date();
}
